import { useCallback, useEffect, useState } from 'react';
import {
  fetchOrganizationContact,
  invalidateOrganizationContactCache
} from '../services/organizationContactService';
import { fallbackOrganizationContact } from '../utils/organizationContactDefaults';

/**
 * Contacts entreprise + support (paramètres système).
 * @param {{ publicAccess?: boolean }} options — true pour Login / pages publiques
 */
export default function useOrganizationContact(options = {}) {
  const { publicAccess = false } = options;
  const [organization, setOrganization] = useState(fallbackOrganizationContact);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (force = false) => {
    setLoading(true);
    try {
      const data = await fetchOrganizationContact({ publicAccess, force });
      setOrganization(data);
    } finally {
      setLoading(false);
    }
  }, [publicAccess]);

  useEffect(() => {
    refresh(false);
  }, [refresh]);

  const invalidateAndRefresh = useCallback(async () => {
    invalidateOrganizationContactCache();
    await refresh(true);
  }, [refresh]);

  return {
    organization,
    support: organization.support,
    entreprise: organization.entreprise,
    loading,
    refresh,
    invalidateAndRefresh
  };
}
